import React from "react";
import "./headerHL.css";

const HeaderHLPure = (props) => {
  const { title, subtitleActive, subtitleText } = props;

  return (
    <div
      container
      className={`headerHLPure-container ${subtitleActive ? "" : "no-subtitle"}`}
      xs={12}
      lg={12}
      md={12}
      sm={12}
    >
      <div className="headerHLPure-titleContainer">
        <h1 className="headerHLPure-titleText ellipsis">{title}</h1>
      </div>
      {subtitleActive !== false ? (
        <div className="headerHLPure-subtitleContainer">
          <p className="headerHLPure-subtitleText ellipsis">{subtitleText}</p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export { HeaderHLPure as default };
